<template>
	<div class="success-popup">
		<div class="success-popup-content">
			<div class="icon-success">
				<img src="@/assets/billing/success.svg" alt="" />
			</div>
			<div class="title">{{ t('billing.success.success') }}</div>
			<div class="subtitle">{{ t('billing.success.successfully_purchased') }}</div>
			<div class="subtitle">
				{{ t('billing.success.time_to_get_healthy') }}
			</div>
		</div>
		<div class="success-popup-footer">
			<button @click="emits('close')" class="btn btn-primary btn-primary-inverted btn-block btn-compact">
				{{ t('billing.success.lets_go') }}
			</button>
		</div>
	</div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const emits = defineEmits(['close'])
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.success-popup {
	height: calc(100vh - 40px);
	max-height: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	padding: 1.5rem 1.5rem;
	background: linear-gradient(176.05deg, #8694f9 0%, #6978e8 67.53%, #3547d1 118.98%);

	&-content {
		flex: 1 0 auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
}

.icon-success {
	margin-top: -2rem;
}

.title {
	color: #fff;
	font-size: 1.6rem;
	margin-top: 1.5rem;
}

.subtitle {
	text-align: center;
	color: #fff;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	margin-top: 1rem;
}
</style>
